import { Id } from 'app/shared/domain/value-objects/id';
import { SettingResponse, SettingNameResponse } from 'app/modules/settings/infrastructure/dto/response/SettingResponse';
import { Setting } from 'app/modules/settings/domain/entity/Setting';
import { SettingOrigin } from 'app/modules/settings/domain/valueObject/SettingOrigin';
import { SettingName, SettingNameValue } from 'app/modules/settings/domain/valueObject/SettingName';
import { SettingValue } from 'app/modules/settings/domain/valueObject/SettingValue';

export class SettingMapper {

    private static _settingsNameToDomain(name: SettingNameResponse): SettingName {
        switch (name) {
            case SettingNameResponse.BIG_RESERVE_UNIT:
                return new SettingName(SettingNameValue.BIG_RESERVE_UNIT);
            case SettingNameResponse.BIG_RESERVE_M2:
                return new SettingName(SettingNameValue.BIG_RESERVE_M2);
            case SettingNameResponse.STOCK_RESERVATION_TIME:
                return new SettingName(SettingNameValue.STOCK_RESERVE_TIME);
            case SettingNameResponse.STOCK_RESERVATION_TIME_CHECKOUT:
                return new SettingName(SettingNameValue.STOCK_RESERVE_TIME_CHECKOUT);
            case SettingNameResponse.CARRIER_PICKUP_BEFORE_CUT_OFF_HOUR:
                return new SettingName(SettingNameValue.CARRIER_PICKUP_BEFORE_CUT_OFF_HOUR);
            case SettingNameResponse.CARRIER_PICKUP_AFTER_CUT_OFF_HOUR:
                return new SettingName(SettingNameValue.CARRIER_PICKUP_AFTER_CUT_OFF_HOUR);
            case SettingNameResponse.CARRIER_SHIPPING_PROCESSING_HOURS_TO_ADD:
                return new SettingName(SettingNameValue.CARRIER_SHIPPING_PROCESSING_HOURS_TO_ADD);
            case SettingNameResponse.CARRIER_INSURANCE:
                return new SettingName(SettingNameValue.CARRIER_INSURANCE);
            case SettingNameResponse.CUT_OFF_HOUR:
                return new SettingName(SettingNameValue.CUT_OFF_HOUR);
            case SettingNameResponse.PICK_HANDLE_PRICE:
                return new SettingName(SettingNameValue.PICK_HANDLE_PRICE);
            case SettingNameResponse.PICK_HANDLE_ACCOUNT:
                return new SettingName(SettingNameValue.PICK_HANDLE_ACCOUNT);
            case SettingNameResponse.IN_MAINTENANCE:
                return new SettingName(SettingNameValue.IN_MAINTENANCE);
            case SettingNameResponse.SHOW_LOT_NUMBER:
                return new SettingName(SettingNameValue.SHOW_LOT_NUMBER);
            case SettingNameResponse.SHIPMENT_ECHO_MAX_WEIGHT_LBS:
                return new SettingName(SettingNameValue.SHIPMENT_ECHO_MAX_WEIGHT_LBS);
            case SettingNameResponse.SHIPMENT_ECHO_MAX_PALLETS:
                return new SettingName(SettingNameValue.SHIPMENT_ECHO_MAX_PALLETS);
            case SettingNameResponse.SAMPLE_ACCOUNT:
                return new SettingName(SettingNameValue.SAMPLE_ACCOUNT);
            case SettingNameResponse.SAMPLE_FULL_PRICE_QUANTITY_LIMIT:
                return new SettingName(SettingNameValue.SAMPLE_FULL_PRICE_QUANTITY_LIMIT);
            case SettingNameResponse.SAMPLE_OVER_LIMIT_DISCOUNT_PERCENT:
                return new SettingName(SettingNameValue.SAMPLE_OVER_LIMIT_DISCOUNT_PERCENT);
            default:
                throw new Error('Invalid SettingName');
        }
    }

    public static toDomain(settingResponse: SettingResponse):Setting | null {
        try {
            return new Setting(
                new Id(settingResponse.id),
                new SettingOrigin(settingResponse.origin),
                this._settingsNameToDomain(settingResponse.name),
                new SettingValue(settingResponse.value),
            );
        } catch (error) {
            return null;
        }
    }

}
